import styles from "../../PPTPlugin/PPTInstallGuidePage.module.css";
import React, {useEffect} from "react";
import { useTranslation, Trans } from "react-i18next";
import {useConfig} from "../../../hooks/useConfig";
import {ReactComponent as STEP_1}   from "./images/step_1_img.svg";
import {ReactComponent as STEP_2}   from "./images/step_2_img.svg";
import {ReactComponent as STEP_3}   from "./images/step_3_img.svg";
import {ReactComponent as STEP_4}   from "./images/step_4_img.svg";
import YuJaButton from "../../../components/standardization/YuJaButton";
import {
    getShortName,
    isChromiumBrowser,
    isFirefoxBrowser,
    isSafariBrowser, sendMsgToExtension,
} from "../../../utils/helpers";
import {useSession} from "../../../hooks/useSession";
import SupportedBrowserList from "./SupportedBrowserList";


export default function GoogleSlidesIntegrationPage({isActive}) {
    const { t } = useTranslation();
    const config = useConfig();
    const {getSession, parseSessionToken} = useSession();


    const onOpen = () => {
        let extensionConfig = config.google_slides_extension;

        if (isChromiumBrowser()) {
            window.open(extensionConfig.chrome);
        } else if (isFirefoxBrowser()) {
            window.open(extensionConfig.firefox);
        } else if (isSafariBrowser()) {
            window.open(extensionConfig.safari);
        }
    }

    useEffect(() => {
        if (!isActive) {
            return;
        }

        let {authorization} = getSession();
        let {institutionId } = parseSessionToken();
        let shortName = getShortName();

        const messageObj = {
            type: "ENGAGE_AUTH_LOGIN",
            enforced: false,
            zone: config.zone,
            shortName: shortName,
            token: authorization,
            institutionId
        };



        let intervalId = setInterval(() => sendMsgToExtension(config.chrome_extension_id, messageObj), 1000);

        return () => {
            if (!!intervalId) {
                clearInterval(intervalId);
            }
        }
    }, [isActive]);

    return (
        <>

            <div style={{height: 10}}/>
            <div className={styles.starterBanner}>
                <div className={styles.column} style={{flex: 1, minWidth: 470, gap: 25}}>
                    <span>{t("integration.googleSlidesTitle")}</span>
                    <span className={styles.description} style={{"color": "#4A4A4A"}}>
                        {t("integration.googleSlidesDesc")}
                    </span>
                </div>
            </div>
            <div style={{height: 30}}/>
            <div className={styles.column} style={{gap: 20}}>
                {(isChromiumBrowser() || isFirefoxBrowser() || isSafariBrowser())
                    ? (
                        <div className={styles.stepCard}>
                            <div className={styles.stepNo}>1</div>
                            <div className={styles.column} style={{gap: 10, flex: 1}}>
                                <span style={{whiteSpace: "nowrap"}}>{t("integration.googleSlidesInstallStep")}</span>
                                <div className={styles.description}>
                                    {isChromiumBrowser() && t("integration.googleSlidesDownloadChrome")}
                                    {isFirefoxBrowser() && t("integration.googleSlidesDownloadFirefox")}
                                    {isSafariBrowser() && t("integration.googleSlidesDownloadAppStore")}
                                </div>
                                <YuJaButton style={{height: 36, marginTop: 15}} onClick={onOpen}>
                                    {t("poll.installExtensionButton")}
                                </YuJaButton>
                            </div>
                            <STEP_1 style={{width: 340, height: 220, marginLeft: "auto"}}/>
                        </div>
                    )
                    : (
                        <div className={styles.stepCard} style={{minHeight: 150}}>
                            <div className={styles.stepNo}>1</div>
                            <div className={styles.column} style={{gap: 10, flex: 1}}>
                                <span style={{whiteSpace: "nowrap"}}>{t("integration.googleSlidesInstallStep")}</span>
                                <div className={styles.description}>
                                    {t("integration.browserNotSupported")}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Chrome</span>
                                    {","}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Firefox</span>
                                    {","}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Safari</span>
                                    {","}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Opera</span>
                                    {","}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Brave</span>
                                    {","}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Edge</span>
                                </div>
                            </div>
                            <SupportedBrowserList/>
                        </div>
                    )
                }

                <div className={styles.stepCard}>
                    <div className={styles.stepNo}>2</div>
                    <div className={styles.column} style={{gap: 10, flex: 1, minWidth: 250}}>
                        <span style={{whiteSpace: "nowrap"}}>{t("integration.googleSlidesLocateStep")}</span>
                        <span className={styles.description}>
                            <Trans
                                i18nKey="integration.googleSlidesLocateDesc"
                                values={{app: t("common.appName")}}
                                components={{bold: <strong/>}}
                            />
                        </span>
                    </div>
                    <div style={{flex: 1}}/>
                    <STEP_2 style={{width: 340, height: 220, marginLeft: "auto"}}/>
                </div>

                <div className={styles.stepCard}>
                    <div className={styles.stepNo}>3</div>
                    <div className={styles.column} style={{gap: 10, flex: 1, minWidth: 250}}>
                        <span style={{whiteSpace: "nowrap"}}>{t("integration.googleSlidesSignInStep")}</span>
                        <span className={styles.description}>
                            <Trans
                                i18nKey="integration.googleSlidesSignInDesc"
                                values={{app: t("common.appName"), signIn: t("auth.signIn")}}
                                components={{bold: <strong/>}}
                            />
                        </span>
                    </div>
                    <div style={{flex: 1}}/>
                    <STEP_3 style={{width: 340, height: 220, marginLeft: "auto"}}/>
                </div>


                <div className={styles.stepCard}>
                    <div className={styles.stepNo}>4</div>
                    <div className={styles.column} style={{gap: 10, flex: 1, minWidth: 250}}>
                        <span style={{whiteSpace: "nowrap"}}>{t("poll.pptInstallStep4Title")}</span>
                        <span
                            className={styles.description}>{t("integration.googleSlidesSignedInDesc")}</span>
                    </div>
                    <div style={{flex: 1}}/>
                    <STEP_4 style={{width: 340, height: 220, marginLeft: "auto"}}/>
                </div>

                {/*<span*/}
                {/*    style={{*/}
                {/*        display: "flex",*/}
                {/*        fontSize: 14,*/}
                {/*        lineHeight: "160%",*/}
                {/*        color: "#191520",*/}
                {/*        alignSelf: "center",*/}
                {/*        alignItems: "center"*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <QUESTION_MARKER style={{marginRight: 5, width: 32, height: 32}}/>*/}
                {/*    {NEED_HELP_TEXT}*/}
                {/*    <span*/}
                {/*        tabIndex={0}*/}
                {/*        className={styles.link}*/}
                {/*        style={{marginLeft: 5}}*/}
                {/*        onClick={() => window.open(YUJA_SUPPORT_LINK)}*/}
                {/*    >{"YuJa Support"}</span>*/}
                {/*</span>*/}

            </div>
        </>
    );
}